<template>
  <div
    class="empty-page d-flex justify-content-center align-items-center flex-column py-4"
  >
    <!-- Icon style (transportistas-like) -->
    <div v-if="icon" class="empty-icon-circle">
      <i :class="icon"></i>
    </div>
    <!-- Legacy image/lottie (kept for backward compat) -->
    <img v-else-if="img" :src="img" alt="empty page" width="450px" />
    <div v-else-if="media" ref="lottieContainer" class="lottie-empty" />
    <h6 class="text-color-black mt-3 text-center">{{ text }}</h6>
  </div>
</template>

<script>
import lottie from "lottie-web";

export default {
  name: "EmptyPage",
  props: {
    icon: { default: null },
    img: { default: null },
    text: { default: null },
    media: { default: null }
  },
  mounted() {
    if (this.media && this.$refs.lottieContainer) {
      lottie.loadAnimation({
        container: this.$refs.lottieContainer,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: this.media
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.empty-page {
  padding: 24px 16px;
}
h6 {
  max-width: 400px;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
}
.lottie-empty {
  width: 100%;
  max-width: 280px;
}
.empty-icon-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #f0faf7;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  i {
    font-size: 32px;
    color: #3ecfb4;
  }
}
</style>
